import { IModel, IAttribute } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';
import { LinkedService } from '../linkedservice/linkedservice';

import { AzureKeyVault } from 'app/model/linkedservice/key-vault';
import { validateAKVLinkedserviceReference } from 'app/shared/utils/linkedservice-validation-util';
import { format } from 'app/shared/utils/string.util';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { driverVersions } from 'app/registries/consts/tabular-consts';
import { LinkedServiceUtils } from './linked-service.utils';
import { SSLMode } from 'app/registries/consts/amazonredshift-consts';

@Metamodel.model({
    name: adfModelTypeMap.amazonRedshift.linkedServiceType,
    display: [
        format(stringResources.ModelName_LinkedServiceTemplate, stringResources.AmazonRedshift_DisplayText),
        format(stringResources.ModelName_LinkedServicesTemplate, stringResources.AmazonRedshift_DisplayText)
    ]
})
export class AmazonRedshiftLinkedService extends LinkedService {

    public static readonly MODEL: IModel;
    public static readonly SERVER_NAME: IAttribute;
    public static readonly PORT: IAttribute;
    public static readonly DATABASE_NAME: IAttribute;
    public static readonly USER_NAME: IAttribute;
    public static readonly PASSWORD: IAttribute;
    public static readonly SSL_MODE: IAttribute;
    public static readonly SSL_INSECURE: IAttribute;

    @Metamodel.attribute({
        display: stringResources.DriverVersion
    })
    public version?: string = driverVersions.v2;

    @Metamodel.attribute({
        display: stringResources.ModelName_ServerName,
        association: 'SERVER_NAME',
        templatable: true
    })
    public serverName?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_Port,
        association: 'PORT',
        templatable: true,
        accepts: ['String', 'Int']
    })
    public port?: number = 5439;

    @Metamodel.attribute({
        display: stringResources.ModelName_DatabaseName,
        association: 'DATABASE_NAME',
        templatable: true
    })
    public databaseName?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_UserName,
        association: 'USER_NAME',
        templatable: true
    })
    public userName?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_Password,
        constraint: {
            validator: validateAKVLinkedserviceReference
        },
        association: 'PASSWORD',
        templatable: true,
        accepts: ['String']
    })
    public password?: string | AzureKeyVault;

    @Metamodel.attribute({
            display: stringResources.SSL_Mode,
            association: 'SSL_MODE',
            templatable: true
        })
    public sslMode: string = SSLMode.VerifyFull;

    @Metamodel.attribute({
            display: stringResources.SSL_Insecure,
            association: 'SSL_INSECURE',
            templatable: true
        })
    public sslinsecure: boolean = false;

    constructor(name?: string, description?: string) {
        super(name, description);
    }

    public convertV1toV2(context: { inlineDataset?: boolean }): AmazonRedshiftLinkedService {
        return LinkedServiceUtils.commonV1ToV2(context, this) as AmazonRedshiftLinkedService;
    }
}
